import { StoreType } from '.';

export const selectLicence = (state: StoreType, licenceModelId: number) => {
  return state.licenceModels.byId[licenceModelId] || {};
};

export const selectActiveLicences = (state: StoreType) => {
  return state.licenceModels.byId;
};
